import { useEffect, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, ErrorMessage, Logo, MainHeaderContainer } from "./style";
import  logoImg  from "../../../assets/images/logo.svg";

const index = () => {
	const location = useLocation();
	const errorMessage =
    location.state?.errorMessage ||
    "Uygulamaya giriş yetkiniz bulunmuyor. Giriş yapabilmeniz gerekiyorsa cozum@kocweb.com mail adresi üzerinden çözüm merkezine ulaşabilirsiniz.";


	useEffect(() => {
		localStorage.clear();
}, [])
	
	return (
		<>
			<MainHeaderContainer>
				<Container id="header-container">
					<Link to="/">
						<Logo src={logoImg} alt="kochr" />
					</Link>
				</Container>
			</MainHeaderContainer>
			<ErrorMessage>{errorMessage}</ErrorMessage>
		</>
	);
};

export default index;